// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:20:08

export default {
  "id": "geometry-stars",
  "slug": "geometry-stars",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/15e7309e294e4f78943d9e39fc0a0d85-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/15e7309e294e4f78943d9e39fc0a0d85/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Geometry Stars",
      "description": "Enjoy the Geometry Stars world with a brand new adventure! New levels, new music, new monsters, new everything!. Flex your clicky finger as you jump, fly and flip your way through dark caves and spiky obstacles. Collect many stars as you can to upgrade your famous characters and find the secrets of this Rhythm-based adventure.\n",
      "instructions": "Easy to understand;\nNice and addictive gameplay;\nAction Music;\nFrenetic adventure;\nAwesome HD Graphics;\nUpgrade system,\n\nUse the Touch or mouse to play",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "geometry",
        "jumping",
        "running"
      ]
    },
    "zh-CN": {
      "title": "几何之星",
      "description": "享受几何之星的新冒险世界！新关卡、新音乐、新怪物，一切皆新！在跳跃、飞行和翻转中，用你的点击手指穿越黑暗洞穴和带刺障碍。收集尽可能多的星星来升级你著名的人物，并揭开这个基于节奏的冒险的秘密。",
      "instructions": "易于理解；\n令人上瘾的游戏玩法；\n动作音乐；\n狂野冒险；\n惊人的高清图形；\n升级系统，\n\n使用触摸屏或鼠标进行游戏",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "几何",
        "跳跃",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "幾何星輝",
      "description": "享受《幾何星河》世界的全新冒險！新關卡、新音樂、新怪物、全新一切！運用你的點擊手指，跳躍、飛翔和翻轉，穿越黑暗的洞窟和釘子般的障礙。盡可能收集星星，來升級你著名的角色，並尋找這個節奏冒險的秘密。",
      "instructions": "容易理解；\n令人著迷的遊戲性；\n動作音樂；\n瘋狂冒險；\n驚艷的高清圖像；\n升級系統，\n\n使用觸控或滑鼠來遊戲",
      "genres": [
        "冒險",
        "靈敏度"
      ],
      "tags": [
        "幾何",
        "跳躍",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "幾何之星",
      "description": "享受全新冒險的幾何之星世界！新關卡、新音樂、新怪物、全新一切！運用你的點擊手指，跳躍、飛翔和翻轉，穿越黑暗洞穴和釘子般障礙。盡可能收集星星，升級你著名的角色，並尋找這個節奏冒險的秘密。",
      "instructions": "易明瞭；\n好玩的連鎖遊戲；\n動作音樂；\n瘋狂冒險；\n驚人的高清圖像；\n升級系統，\n\n使用觸控或滑鼠來遊戲",
      "genres": [
        "冒險",
        "靈敏度"
      ],
      "tags": [
        "幾何學",
        "跳躍",
        "奔跑"
      ]
    },
    "ja": {
      "title": "幾何スターズ",
      "description": "Geometry Starsの世界をbrand newな冒険で楽しみましょう！新しいレベル、新しい音楽、新しいモンスター、すべてが新しいです！ジャンプ、飛び、転がりながら暗い洞窟と棘のある障害物を乗り越え、クリック指を鍛えましょう。できるだけ多くの星を集め、有名なキャラクターをアップグレードし、リズムに基づく冒険の秘密を見つけ出しましょう。",
      "instructions": "簡単に理解できる；\n快適で魅力的なゲームプレイ；\nアクション音楽；\n興奮する冒険；\n素晴らしいHDグラフィック；\nアップグレードシステム，\n\nタッチやマウスを使用して遊ぶ",
      "genres": [
        "アドベンチャー",
        "アギレシティー"
      ],
      "tags": [
        "幾何学",
        "ジャンプ",
        "走り"
      ]
    },
    "ko": {
      "title": "지오메트리 스타즈",
      "description": "지오메트리 스타즈 세계를 새로운 모험과 함께 즐겨보세요! 새로운 레벨, 새로운 음악, 새로운 몬스터, 모든 것이 새로워요! 점프하고 날아다니며 돌림으로써 어둡고 날카로운 장애물을 통과하세요. 가능한 많은 별을 모아 캐릭터를 업그레이드하고 리듬 기반 모험의 비밀을 찾아보세요.",
      "instructions": "이해하기 쉬움;\n좋고 중독성 있는 게임 플레이;\n액션 음악;\n섬세한 모험;\nawesome HD 그래픽;\n업그레이드 시스템,\n\n터치나 마우스를 사용하여 게임을 플레이하세요.",
      "genres": [
        "모험",
        "민첩력"
      ],
      "tags": [
        "了几미터",
        "점프",
        "달리기"
      ]
    },
    "fr": {
      "title": "Étoiles de Géométrie",
      "description": "Profitez du monde de Geometry Stars avec une nouvelle aventure ! Nouveaux niveaux, nouvelle musique, nouveaux monstres, tout est nouveau ! Détendez votre doigt d'appui en sautant, volant et retournant pour traverser des grottes sombres et des obstacles pointus. Collectez aussi nombreuses étoiles que possible pour améliorer vos personnages célèbres et découvrir les secrets de cette aventure basée sur le rythme.",
      "instructions": "Facile à comprendre;\nJeu sympa et accrocheur;\nMusique d'action;\nAventure frenétique;\nGraphismes HD incroyables;\nSystème de mise à niveau,\n\nUtilisez le Touch ou la souris pour jouer",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "géométrie",
        "saut",
        "course"
      ]
    }
  }
};
